import React from "react";
import AttributesPanel from "./AttributesPanel";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import { IArtifactInformationProps } from "./definitions";
import { CommentsSection } from "../../../components/comments-section/CommentsSection";

const ArtifactInformation: React.FC<IArtifactInformationProps> = ({
    statusAndOwnershipInformationPanel,
    financialInformationPanel,
    otherInformationPanel,
    spacesPanel,
    artifactId,
    artifactType,
}) => {
    const renderRealProperty = () => (
        <>
            <Row widths={["50%", "50%"]}>
                <AttributesPanel
                    height="328px"
                    title="Status and Ownership"
                    rows={statusAndOwnershipInformationPanel}
                    type="outline"
                    spacingInset="400"
                />
                <AttributesPanel
                    height="328px"
                    title="Financial information"
                    rows={financialInformationPanel}
                    type="outline"
                    spacingInset="400"
                />
            </Row>
            <Box height="15px" />
            <Row widths={["50%", "50%"]}>
                <AttributesPanel
                    height="328px"
                    title="Spaces"
                    rows={spacesPanel}
                    type="outline"
                    spacingInset="400"
                />
                <AttributesPanel
                    height="328px"
                    title="Other information"
                    rows={otherInformationPanel}
                    type="outline"
                    spacingInset="400"
                />
            </Row>
        </>
    );

    const renderParcel = () => (
        <>
            <Row widths={["50%", "50%"]}>
                <AttributesPanel
                    height="328px"
                    title="Status and Ownership"
                    rows={statusAndOwnershipInformationPanel}
                    type="outline"
                    spacingInset="400"
                />
                <AttributesPanel
                    height="328px"
                    title="Financial information"
                    rows={financialInformationPanel}
                    type="outline"
                    spacingInset="400"
                />
            </Row>
            <Box height="15px" />
            <Row width="100%" widths={["100%"]} spacing="400">
                <AttributesPanel
                    height="242px"
                    title="Other information"
                    rows={otherInformationPanel}
                    type="outline"
                    spacingInset="400"
                />
            </Row>
        </>
    );

    return (
        <>
            {artifactType === "REAL_PROPERTY" ? renderRealProperty() : renderParcel()}
            <Box height="15px" />
            <CommentsSection
                artifactId={artifactId}
                artifactType={artifactType}
                sectionProps={{
                    thumbnailSize: "medium",
                    commentedByTextType: "h300",
                    createdOnTextType: "b300",
                    type: "outline",
                }}
            />
        </>
    );
};

export default ArtifactInformation;
